import { degreesToRadians } from './degreesToRadians';

// Function takes two objects, that contain coordinates to a starting and destination location.
export type Coords = {
    lat: number;
    lng: number;
};

export function calcDistance(startCoords: Coords, destCoords: Coords): number {
    // Convert from degrees to radians
    let startingLat = degreesToRadians(startCoords.lat);
    let startingLong = degreesToRadians(startCoords.lng);
    let destinationLat = degreesToRadians(destCoords.lat);
    let destinationLong = degreesToRadians(destCoords.lng);

    // Radius of the Earth in kilometers
    let radius = 6571;

    // Haversine equation
    let distanceInKilometers = Math.acos(Math.sin(startingLat) * Math.sin(destinationLat) +
        Math.cos(startingLat) * Math.cos(destinationLat) *
        Math.cos(startingLong - destinationLong)) * radius;
    return distanceInKilometers;
}
